"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ItemReplacementWidget_1 = __importDefault(require("./ItemReplacementWidget"));
exports.default = ItemReplacementWidget_1.default;
